import { FailedAgreementIcon } from "icons/action/FailedIcon";
import { SuccessTick } from "icons/auth/SuccessTick";
import { useNavigate, useParams } from "react-router-dom";
import {
  decode,
  encode,
  customerFacingPaymentError,
} from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

const PaymentLinkSuccess = ({ success, failedReason, requestStatus }: any) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const testAttrs = useTestAttrsFactory();

  let clusterId = encode(decode(id || "")?.split("_")[1], "ci_");
  return (
    <>
      {true ? (
        <div
          className="w-full h-full grid place-items-center"
          {...testAttrs("request-status", "Payment link request status")}
        >
          <div className="flex items-center justify-center lg:h-full flex-col text-center p-5 max-w-[630px]">
            {requestStatus === "Pending" ? (
              <SuccessTick aria-hidden="true" />
            ) : (
              <FailedAgreementIcon aria-hidden="true" />
            )}
            <div className="text-2xl mt-[40px]">
              {requestStatus === "Pending"
                ? "Request received"
                : "Request not approved"}
            </div>
            <div className="text-base mt-[16px] text-txtParagraph ">
              {requestStatus === "Pending"
                ? "Your request for a new payment link has been received. We are processing it and will get back to you shortly. We appreciate your patience."
                : "Your request for a new payment link could not be approved at this time. Please contact our support team if you need further assistance."}
            </div>

            <div
              className="mt-[40px] lg:text-base text-sm cursor-pointer text-blue hover:!text-btnPrimaryHover"
              role="button"
              tabIndex={0}
              {...testAttrs("back-to-dashboard", "Back to dashboard")}
              onClick={() => navigate(`/${clusterId}/dashboard`)}
            >
              Back to dashboard
            </div>
          </div>
        </div>
      ) : (
        <div
          className="w-full h-full grid place-items-center"
          {...testAttrs("request-failed", "Payment link request failed")}
        >
          <div className="flex items-center justify-center lg:h-full flex-col text-center p-5 w-full max-w-[630px]">
            <FailedAgreementIcon aria-hidden="true" />
            <div className="text-2xl mt-[40px]">Request Failed!</div>
            <div className="text-base mt-[16px] text-txtParagraph pb-5">
              Your request for a new payment link has been failed.
            </div>
            <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-2 px-3 lg:text-lg text-base text-txtParagraph break-words">
              {customerFacingPaymentError(failedReason) || "Payment Failed"}
            </div>
            <div
              className="mt-[40px] lg:text-base text-sm cursor-pointer text-blue hover:!text-btnPrimaryHover"
              role="button"
              tabIndex={0}
              {...testAttrs("back-to-dashboard", "Back to dashboard")}
              onClick={() => navigate(`/${clusterId}/dashboard`)}
            >
              Back to dashboard
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentLinkSuccess;
